module.exports = __webpack_public_path__ + "img/teacher_horn.6fc46845.svg";